import {
  Box,
  Flex,
  Group,
  Kbd,
  Overlay,
  Paper,
  SimpleGrid,
  Text,
  useComputedColorScheme,
} from '@mantine/core';
import React from 'react';

interface Shortcut {
  label: string;
  keys: string[];
}

const shortcuts: Shortcut[] = [
  { label: 'Toggle sidebar ', keys: ['['] },
  { label: 'Toggle light/dark mode', keys: ['mod', 'J'] },
  { label: 'Open create claim modal', keys: ['mod', 'B'] },
  { label: 'Open bulk claim modal', keys: ['Shift', 'mod', 'B'] },
  { label: 'Open patient claim history', keys: ['F4'] },
  { label: 'Logout', keys: ['Shift', 'mod', 'P'] },
  { label: 'Navigate to dashboard', keys: ['mod', '1'] },
  { label: 'Navigate to claims', keys: ['mod', '2'] },
  { label: 'Navigate to submissions', keys: ['mod', '3'] },
  { label: 'Navigate to remittance', keys: ['mod', '4'] },
];

export interface ShortcutCheatsheetProps {
  onClose: () => void;
}

const testIsMac = () => {
  if ((navigator as any).userAgentData) {
    return /macOS|iPhone|iPod|iPad/.test(
      (navigator as any).userAgentData.platform
    );
  } else if (navigator.platform) {
    return /Mac|iPhone|iPod|iPad/.test(navigator.platform);
  }
  return false;
};

export const ShortcutCheatsheet: React.FC<ShortcutCheatsheetProps> = ({
  onClose,
}) => {
  const colorScheme = useComputedColorScheme('dark');
  const isDark = colorScheme === 'dark';
  const isMac = testIsMac();
  const modKey = isMac ? '⌘' : 'Ctrl';

  const handleOverlayClick = () => onClose();
  return (
    <Box
      pos={'fixed'}
      top={0}
      left={0}
      w={'100vw'}
      h={'100vh'}
      display={'flex'}
      style={{
        justifyContent: 'center',
        alignItems: 'center',
      }}
      onClick={handleOverlayClick}
    >
      <Overlay opacity={0.2} />
      <Box bg={isDark ? '#2c2c2cff' : 'white'} p="xl" mx="md">
        <SimpleGrid cols={2} spacing="lg" w={'100%'}>
          {shortcuts.map(({ label, keys }) => (
            <Paper
              key={label}
              shadow="sm"
              radius="md"
              withBorder
              style={{
                background: isDark ? '#3a3a3a' : '#fafafa',
                borderColor: isDark ? '#444' : '#e0e0e0',
              }}
            >
              <Flex justify="space-between" align="center" p="md">
                <Text fw={600} c={isDark ? 'gray.0' : 'dark'}>
                  {label}
                </Text>
                <Group gap="xs">
                  {keys.map((key, i) => (
                    <Kbd key={i}>{key === 'mod' ? modKey : key}</Kbd>
                  ))}
                </Group>
              </Flex>
            </Paper>
          ))}
        </SimpleGrid>
      </Box>
    </Box>
  );
};
